
//
// Import Widget Library
//

var Widgets = {
  'auto-slugify':          require('./auto-slugify'),
  'tiny-modal':            require('./tiny-modal'),
  'ajax-cart':             require('./ajax-cart'),
  'cart-drawer':           require('./cart-drawer'),
  'cc-expiry':             require('./cc-expiry'),
  'cc-validate':           require('./cc-validate'),
  'chart':                 require('./chart'),
  'conditional-disable':   require('./conditional-disable'),
  'char-limit-indicator':  require('./char-limit-indicator'),
  'date-input':            require('./date-input'),
  'dropdown':              require('./dropdown'),
  'email-dispatch':        require('./email-dispatch'),
  'expander':              require('./expander'),
  'expiry-input':          require('./expiry-input'),
  'fancy-row-highlight':   require('./fancy-row-highlight'),
  'fast-tooltips':         require('./fast-tooltips'),
  'filter-table':          require('./filter-table'),
  'flash-alert':           require('./flash-alert'),
  'image-preview':         require('./image-preview'),
  'implicit-link':         require('./implicit-link'),
  'live-input':            require('./live-input'),
  'modal-action-button':   require('./modal-action-button'),
  'number-input':          require('./number-input'),
  'personaliser':          require('./personaliser'),
  'password-strength':     require('./password-strength'),
  'pin-input':             require('./pin-input'),
  'random-pin':            require('./random-pin'),
  'sort-triggers':         require('./sort-triggers'),
  'stock-level-input':     require('./stock-level-input'),
  'toggle':                require('./toggle'),
  'voucher-configurator':  require('./voucher-configurator'),
  'void-modal':            require('./void-modal'),
  'error-modal':           require('./error-modal'),
  'redeem-modal':          require('./redeem-modal'),
  'delete-campaign-modal': require('./delete-campaign-modal'),
  'preview-modal':         require('./preview-modal'),
  'qr-size-adjuster':      require('./qr-size-adjuster'),
  'async-campaign-stats':  require('./async-campaign-stats'),
  'ajax-pending-notice':   require('./ajax-pending-notice'),
  'ajax-template-notice':  require('./ajax-template-notice'),
  'ajax-batch-job-report': require('./ajax-batch-job-report'),
};


//
// Widget Metasystem
//

var allWidgets = [];
var genWid = (function (i) { return function () { return i++; }; }(0));

window.getWidgetById = function getWidgetById (wid) {
  return allWidgets[wid];
};

window.getWidgetAtDom = function getWidgetAtDom (el) {
  return getWidgetById($(el).attr('data-widget-id'));
}

window.initAllWidgetsWithin = function (subdom) {
  [].reverse.apply( $('[data-widget]', subdom) ).toArray().forEach(initWidget);
};

function initWidget (el) {
  var types = el.dataset.widget.split(' '), config = el.dataset;

  for (var i in types) {
    var type = types[i];
    if (Widgets[type]) {
      var wid = genWid();
      allWidgets[wid] = Widgets[type]($(el), config);
      $(el).attr('data-widget-id', wid);
    } else {
      console.warn('No such widget:', type);
    }
  }

  return allWidgets[wid];
}


//
// Export widget library
//

module.exports = {
  initAllWithin: initAllWidgetsWithin
};

